// Renders a UTC instant as KST wall-clock text inside a <time> tag.
// Boundary-agnostic: formatKst assembles the string from Intl parts
// anchored to Asia/Seoul, so the output is identical whether this
// component runs on the server or in a visitor's browser. We previously
// tried a client variant via useSyncExternalStore so visitors abroad
// would see their own clock, but it tripped React #418 with Next 16's
// streaming hydration. KST is the right default for the primary
// audience; revisit when global users are an actual business goal.
import { formatKst } from "@/lib/utils";

type Variant = "date" | "datetime" | "time";

const PATTERNS: Record<Variant, string> = {
  date: "yyyy.MM.dd",
  datetime: "yyyy.MM.dd HH:mm",
  time: "HH:mm",
};

type Props = {
  iso: string | Date;
  variant?: Variant;
  className?: string;
};

export function LocalDateTime({ iso, variant = "datetime", className }: Props) {
  const date = typeof iso === "string" ? new Date(iso) : iso;
  const text = formatKst(date, PATTERNS[variant]);
  return (
    <time dateTime={date.toISOString()} className={className}>
      {text}
    </time>
  );
}
